import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";
import { ContactApi } from "../../apis/ContactApi"; // Adjust the import path

const ViewContact = () => {
  const { id } = useParams();
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alreadyRead, setAlreadyRead] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return;

    setLoading(true);

    ContactApi.getContactById(id) // Make sure your API function exists
      .then((res) => {
        setContact(res.data?.data);
        setAlreadyRead(res.data?.data?.active == 'N')
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching contact:", err);
        setError("Failed to load contact details.");
        setLoading(false);
      });

      
  }, [id]);

  useEffect(() => {
    readContactUs();
  }, [alreadyRead]);

  const readContactUs = () => {
    if (alreadyRead != null && !alreadyRead) {
      ContactApi.readContactUs({ contact_us_id: id })
        .then((res) => {
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching contact:", err);
          setError("Failed to load contact details.");
          setLoading(false);
        });
    }
  }

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner color="primary" />
        <p>{props.t("Loading contact details...")}</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center mt-5">
        <p className="text-danger">{error}</p>
      </Container>
    );
  }

  if (!contact) {
    return (
      <Container className="text-center mt-5">
        <p>{props.t("No contact found.")}</p>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ size: 8, offset: 2 }}>
          <Card>
            <CardBody>
              <h3 className="mb-3">{props.t("Contact Details")}</h3>
              <hr />

              <p><strong>Name:</strong> {contact.name}</p>
              <p><strong>Email:</strong> {contact.email}</p>
              <p><strong>Phone:</strong> +{contact.country_phone_code} {contact.phone_no}</p>
              <p><strong>Message:</strong> {contact.message}</p>
              {/* <p><strong>Subject:</strong> {contact.subject}</p> */}
              {/* <p><strong>Created At:</strong> {contact.created_at}</p> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ViewContact;
